module.exports = __webpack_public_path__ + "img/temp_user_logo.0ceebb9f.png";